import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocComponentFooter } from 'commons/components/components-wrapper/poc-component-footer.component';
import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import { WorkflowStyledComponent } from 'commons/components/workflow-overlay/workflow-overlay.style';
import { useTranslation } from 'core/i18n/i18n';
import { AutomationRulesCardLayout } from '../styled/automation-rules.style';

interface TriggerActionsLayoutProps {
    children?: React.ReactNode;
    headerText?: string;
    saveText?: string;
    isValid?: boolean;
    showResetChanges?: boolean;
    onClose?: VoidFunction;
    onSaveHandler?: VoidFunction;
    onResetChangesHandler?: VoidFunction;
}

export const TriggerActionsLayout = (props: TriggerActionsLayoutProps) => {
    const {
        children,
        headerText = '',
        saveText = '',
        isValid = true,
        showResetChanges = true,
        onClose = () => {},
        onSaveHandler = () => {},
        onResetChangesHandler,
    } = props;

    const { t } = useTranslation();

    return (
        <WorkflowStyledComponent
            visible
            disableEscapeKeydown
            className="show-header"
            controlled
            noAutoFocus
            closeIconProps={{ onclick: onClose }}
        >
            <PocComponentHeader>{headerText}</PocComponentHeader>
            <div slot="content" style={{ backgroundColor: '#F5F5F2', overflow: 'overlay' }}>
                <AutomationRulesCardLayout className="col-dir" padding="32px" style={{ width: '100%' }}>
                    {children}
                </AutomationRulesCardLayout>
            </div>
            <PocComponentFooter style={{ borderTop: '1px solid lightgrey' }}>
                <div slot="suffix">
                    <AutomationRulesCardLayout padding="0">
                        {showResetChanges ? (
                            <PocButton onClick={onResetChangesHandler} variant="secondary">
                                {t('settings.system.automation-rules.fields.type.reset_changes')}
                            </PocButton>
                        ) : undefined}
                        <PocButton disabled={!isValid} onClick={onSaveHandler}>
                            {saveText}
                        </PocButton>
                    </AutomationRulesCardLayout>
                </div>
            </PocComponentFooter>
        </WorkflowStyledComponent>
    );
};

TriggerActionsLayout.displayName = 'TriggerActionsLayout';
